import { useContext } from 'react';
import { SharedValueContext } from './shared-values.model';
import { DefaultSharedStore } from './default-shared-store';
export function usePrintSharedValues() {
    var store = useContext(SharedValueContext);
    return function print() {
        var values = getStoreValues(store);
        console.info(values);
    };
}
function getStoreValues(store) {
    var values = {};
    for (var _i = 0, _a = store.allKeys(); _i < _a.length; _i++) {
        var key = _a[_i];
        values[key] = getStoreValue(key, store);
    }
    return values;
}
function getStoreValue(key, store) {
    var value = store.getValue(key);
    return isStore(value) ? getStoreValues(value) : value;
}
function isStore(value) {
    return value instanceof DefaultSharedStore;
}
//# sourceMappingURL=print-shared-values.js.map